// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"ca9ddaa1","75":"faf36ef6","204":"faf36ef6","216":"a43a4b87","688":"faf36ef6"}[chunkId] + ".chunk.css";
};